<script>
import AuthLayout from "../templates/AuthLayout.vue";
import BasicInput from "../../../theme/atoms/BasicInput.vue";
import BasicButton from "../../../theme/atoms/BasicButton.vue";
import LoginCard from "../organisms/Login/LoginCard.vue";
import LoginModal from "../organisms/Login/LoginModal.vue";
import {getRecentSessionProfiles, removeRecentSessionProfile} from "../../../services/SessionService";

export default {
    name: "LoginPage",
    components: {
        LoginModal,
        LoginCard,
        AuthLayout,
        BasicInput,
        BasicButton
    },
    props: {
        loginCandidates: {
            type: Array,
            required: false,
        },
        errors: {
            type: Array,
            required: false
        }
    },
    data() {
        return {
            recentLogins: []
        }
    },
    methods: {
        handleClick(candidate) {
            this.$refs.loginModal.open(candidate);
        },
        handleRemove(candidate) {
            removeRecentSessionProfile(candidate.id);
            this.recentLogins = this.getLatestRecentLogin();
        },
        getLatestRecentLogin() {
            return getRecentSessionProfiles().slice(-3).reverse();
        },
        handleForgotPassword(message) {
            this.$refs.loginModal.close();
            this.$notify({
                type: 'success',
                text: message
            });
        }
    },
    mounted() {
        if (!this.loginCandidates.length) {
            this.recentLogins = this.getLatestRecentLogin();
        }
    }
}
</script>

<template>
    <auth-layout>
        <login-card  @click="handleClick" @remove="handleRemove" :recent-logins="recentLogins"
                    :login-candidates="loginCandidates" :errors="errors"/>
        <login-modal v-on:forgot-password-success="handleForgotPassword" ref="loginModal"></login-modal>
    </auth-layout>
</template>
